<template>
  <v-layout row wrap justify-center>

<v-flex xs11>
     <v-stepper non-linear>
      <v-stepper-header>
        <v-stepper-step step="En" editable  :rules="[() => rulesEn]">English</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="Ro" editable  :rules="[() => rulesRo]">Romana</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="Sr" editable  :rules="[() => rulesSr]">Српски</v-stepper-step>
      </v-stepper-header>
   

 
      <!-- <v-btn @click="enm()" :class="{'primary': en,'green darken-3':addedEn}" >English</v-btn>
    
     
      <v-btn @click="rom()" :class="{'primary': ro,'green darken-3':addedRo}">Romana</v-btn>
   
     
      <v-btn @click="srm()" :class="{'primary': sr,'green darken-3':addedSr}">Српски</v-btn> -->
   
    <v-stepper-items>
      <v-stepper-content step="En">
      <keep-alive> 
  <web-edit-artefact  :formUpload="formUpload" @newMarker="marker = $event" @newLocation="place = $event" :place="place" :marker="marker" :center="center" :newLocation="newLocation"  :lang="'en'" @save="changeEn($event)"  @maybe="dialogOpen=true" :rules="[() => rulesEn]"></web-edit-artefact>
   </keep-alive>
      </v-stepper-content>
      <v-stepper-content step="Ro">
   <keep-alive>
  <web-edit-artefact :formUpload="formUpload" @newMarker="marker = $event" @newLocation="place = $event" :place="place" :marker="marker" :center="center" :newLocation="newLocation" :lang="'ro'" @save="changeRo($event)"  @maybe="dialogOpen=true"  @changeObj="addedRo=false" :rules="[() => rulesRo]"></web-edit-artefact>
   </keep-alive>
      </v-stepper-content>
      <v-stepper-content step="Sr">
   <keep-alive>
  <web-edit-artefact  :formUpload="formUpload" @newMarker="marker = $event" @newLocation="place = $event" :place="place" :marker="marker" :center="center" :newLocation="newLocation"  :lang="'sr'" @save="changeSr($event)" @maybe="dialogOpen=true"   @changeObj="addedSr=false" :rules="[() => rulesSr]"></web-edit-artefact>
   </keep-alive>
      </v-stepper-content>
    </v-stepper-items>
     </v-stepper>
  </v-flex> 


       <v-dialog v-model="dialogOpen" max-width="500px">
        <v-card >
          <v-card-title>
            <p v-if="!rulesEn && !rulesRo && !rulesSr">
              Your artefact won't be visible in any language please complete all fields(including text-fields for the desired language)
              <br>
              By continuing you're saving your artefacts to your drafts , visible only to your account!
            </p>
            <p v-else>You can change the visibility of your artefacts by adding language versions, your artefact will be visible in:</p>
          </v-card-title>
          <v-card-text class="text-xs-center">
            <p v-if="rulesEn">English </p>
            <p v-if="rulesRo"> Romana</p>
            <p v-if="rulesSr"> Српски</p>

            <p v-if="rulesEn && !rulesRo && !rulesSr ">The Serbian and Romanian versions will be shown in English</p>
            <p v-if="rulesEn && !rulesRo && rulesSr ">The Romanian version will be shown in English</p>
            <p v-if="rulesEn && rulesRo && !rulesSr ">The Serbian version will be shown in English</p>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" flat @click.stop="onUpdateArtefact">Continue</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.stop="dialogOpen=false">Change</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> 

  </v-layout>
</template>

<script>
export default {
  props: ["id"],
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    formUpload() {
      return this.$store.getters.loadArtefactSingle(this.id);
    },
    rulesEn() {
      return (
        this.formUpload.title.en != "" &&
        this.formUpload.description.en != "" &&
        this.checkTextFields("en")
      );
    },
    rulesRo() {
      return (
        this.formUpload.title.ro != "" &&
        this.formUpload.description.ro != "" &&
        this.checkTextFields("ro")
      );
    },
    rulesSr() {
      return (
        this.formUpload.title.sr != "" &&
        this.formUpload.description.sr != "" &&
        this.checkTextFields("sr")
      );
    }
  },
  data() {
    return {
      newLocation: false,
      center: { lat: 45.76204321990797, lng: 21.24094273988112 },
      marker: {
        position: { lat: 45.76204321990797, lng: 21.24094273988112 }
      },
      place: {
        formatted_address: ""
      },
      dialogOpen: false,
      en: true,
      sr: false,
      ro: false,
      addedEn: false,
      addedSr: false,
      addedRo: false
    };
  },
  methods: {
    showEnglish(lang) {
      this.formUpload.title[lang] = this.formUpload.title.en;
      this.formUpload.description[lang] = this.formUpload.description.en;
      for (var media of this.formUpload.uploads)
        if (media.type == "text") media.value[lang] = media.value.en;
    },
    onUpdateArtefact() {
      if (this.rulesEn && !this.rulesRo) this.showEnglish("ro");
      if (this.rulesEn && !this.rulesSr) this.showEnglish("sr");
      if (this.user.role == "Contributor") {
        this.formUpload.reviewed = false;
      }
      this.$store.dispatch("updateArtefact", this.formUpload);
      this.$router.push({ path: "/artefacts/" + this.formUpload._id });
    },
    checkTextFields(lang) {
      var ok = true;
      for (var media of this.formUpload.uploads)
        if (media.type == "text" && media.value[lang] == "") ok = false;
      return ok;
    },
    changeEn(obj) {
      this.formUpload = obj;
      this.addedEn = true;
    },
    changeSr(obj) {
      this.formUpload = obj;
      this.addedSr = true;
    },
    changeRo(obj) {
      this.formUpload = obj;
      this.addedRo = true;
    },
    srm() {
      this.sr = true;
      this.en = false;
      this.ro = false;
    },
    rom() {
      this.ro = true;
      this.en = false;
      this.sr = false;
    },
    enm() {
      this.en = true;
      this.sr = false;
      this.ro = false;
    }
  },
  mounted() {
    this.center = {
      lat: parseFloat(this.formUpload.location.geometry.location.lat),
      lng: parseFloat(this.formUpload.location.geometry.location.lng)
    };
    this.marker = {
      position: {
        lat: parseFloat(this.formUpload.location.geometry.location.lat),
        lng: parseFloat(this.formUpload.location.geometry.location.lng)
      }
    };
    this.place = {
      formatted_address: this.formUpload.location.formatted_address
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Common/EditArtefact.vue